import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import './Contact.css';
import { Breadcrumb } from 'antd';
import Footer from '../../Footer';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next'; // Ajout de l'import pour la traduction


const Contact = () => { 
    const defaultProps = {
        center: {
            lat: 59.95,
            lng: 30.33,
        },
        zoom: 11,
    };
    const { t, i18n } = useTranslation();

        return (
            <div className="service_contact">
                <Helmet>
                    <title>{t('Professional Inspectors - Contact, Coordonnées, Adresse, et Carte')}</title>
                    <meta name="description" content={t("Contactez Professional Inspectors pour tous vos besoins en contrôle de qualité. Retrouvez nos coordonnées, adresse et carte pour nos bureaux à Tunis et Sfax.")} />
                    <meta name="keywords" content={t("Professional Inspectors, contrôle qualité, Tunis, Sfax, inspection, sécurité, entreprise, experts, professionnels")} />
                </Helmet>

                <div className="container_15">
                        <Breadcrumb separator="" className="breadcrumb-text">
                            <Breadcrumb.Item href="/"> </Breadcrumb.Item>
                            <Breadcrumb.Item> </Breadcrumb.Item>
                        </Breadcrumb>

                    <div className="row">
                        <div className="pic service_cover">
                            <a
                                href="https://www.google.com/maps/place/Professional+Inspectors/@36.8469664,10.1486585,17z/data=!3m1!4b1!4m6!3m5!1s0x12fd332a0a2a8927:0xd53d5f3bfba0171a!8m2!3d36.8469621!4d10.1512334!16s%2Fg%2F11vkbpprm2?entry=ttu"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src="images/map.png" className="img-fluid intro_image" alt="Map" />
                            </a>
                        </div>
                        <div className="col-sm-7 contact_card">
                            <h3> Contact</h3>
                            <ul>
                                <li>{t("Directeur général: Mohamed SELLAMI")}</li>
                                <li>{t("Business developer: Amine SELLAMI")}</li>

                                <li>
                                    <i className="fa fa-phone"></i> (+216) 71 889 071
                                </li>
                                <li>
                                    <i className="fa fa-mobile"></i> (+216) 29 370 529</li>
                                <li>
                                    <i className="fa fa-envelope"></i><strong> mohamed.sellami@professional-inspectors.com</strong>  

                                </li>


                                <li>
                                    <i className="fa fa-map-marker"></i>{t(" 11 Rue Ali Ben Khelifa 1013 Menzah 9 - TUNIS")}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="container_15">
                    <div className="row">
                        <div className="pic service_cover">
                            <a
                                href="https://www.google.com/maps/place/Professional+Inspectors/@34.7249153,10.7366433,17z/data=!3m1!4b1!4m6!3m5!1s0x13002d8d32fdd76b:0xbaa682a5f42c01be!8m2!3d34.7249109!4d10.7392182!16s%2Fg%2F11lct8nzdq?entry=ttu"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src="images/sfaxLoc.png" className="img-fluid intro_image" alt="Map" />
                            </a>
                        </div>
                        <div className="col-sm-7 contact_card">
                            <h3> Contact</h3>
                            <ul>
                                <li>{t("Business developer: Amine SELLAMI")}</li>
                                <li>
                                    <i className="fa fa-phone"></i> (+216) 74 453 013
                                </li>
                                <li>
                                    <i className="fa fa-mobile"></i> (+216) 29 370 529
                                    </li>
                                <li>
                                    <i className="fa fa-envelope"></i><strong> amine.sellami@professional-inspectors.com</strong>
                                </li>
                                <li>
                                    <i className="fa fa-map-marker"></i> {t("Route de Gabès Km 3, 3000 Sfax")}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        );
    }


export default Contact;
